/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/the-hangover-test.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/the-hangover-test.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/the-hangover-test.mdx';

const metadata = {
  slug: "the-hangover-test",
  title: "The Hangover Test",
  author: "Christian Battaglia",
  description: "The true test of whether you know a city's transit system: can you navigate it hungover on a Saturday morning while dodging the Women's March crowd? A dispatch from week two in New York.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/oliver-cole-199976.webp",
  date: "2018-01-20T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["NYC","NJ Transit","transportation","Alphabet City","subway","Women's March","Spotify","New York","travel"],
};

export const Route = createFileRoute('/blog/posts/the-hangover-test')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/the-hangover-test',
    image: '/og/blog/the-hangover-test.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
